module.exports = [
  { code: 100, label: 'Continue' },
  { code: 101, label: 'Switching Protocols' },
  { code: 102, label: 'Processing (WebDAV; RFC 2518)' },
  { code: 103, label: 'Early Hints (RFC 8297)' },
  { code: 200, label: 'OK' },
  { code: 201, label: 'Created' },
  { code: 202, label: 'Accepted' },
  { code: 203, label: 'Non-Authoritative Information (since HTTP/1.1)' },
  { code: 204, label: 'No Content' },
  { code: 205, label: 'Reset Content' },
  { code: 206, label: 'Partial Content' },
  { code: 207, label: 'Multi-Status (WebDAV; RFC 4918)' },
  { code: 208, label: 'Already Reported (WebDAV; RFC 5842)' },
  { code: 226, label: 'IM Used (RFC 3229)' },
  { code: 300, label: 'Multiple Choices' },
  { code: 301, label: 'Moved Permanently' },
  { code: 302, label: 'Found (Previously "Moved temporarily")' },
  { code: 303, label: 'See Other (since HTTP/1.1)' },
  { code: 304, label: 'Not Modified' },
  { code: 305, label: 'Use Proxy (since HTTP/1.1)' },
  { code: 306, label: 'Switch Proxy' },
  { code: 307, label: 'Temporary Redirect (since HTTP/1.1)' },
  { code: 308, label: 'Permanent Redirect' },
  { code: 400, label: 'Bad Request' },
  { code: 401, label: 'Unauthorized' },
  { code: 402, label: 'Payment Required' },
  { code: 403, label: 'Forbidden' },
  { code: 404, label: 'Not Found' },
  { code: 405, label: 'Method Not Allowed' },
  { code: 406, label: 'Not Acceptable' },
  { code: 407, label: 'Proxy Authentication Required' },
  { code: 408, label: 'Request Timeout' },
  { code: 409, label: 'Conflict' },
  { code: 410, label: 'Gone' },
  { code: 411, label: 'Length Required' },
  { code: 412, label: 'Precondition Failed' },
  { code: 413, label: 'Payload Too Large' },
  { code: 414, label: 'URI Too Long' },
  { code: 415, label: 'Unsupported Media Type' },
  { code: 416, label: 'Range Not Satisfiable' },
  { code: 417, label: 'Expectation Failed' },
  { code: 418, label: 'I\'m a teapot (RFC 2324, RFC 7168)' },
  { code: 421, label: 'Misdirected Request' },
  { code: 422, label: 'Unprocessable Entity' },
  { code: 423, label: 'Locked (WebDAV; RFC 4918)' },
  { code: 424, label: 'Failed Dependency (WebDAV; RFC 4918)' },
  { code: 425, label: 'Too Early (RFC 8470)' },
  { code: 426, label: 'Upgrade Required' },
  { code: 428, label: 'Precondition Required (RFC 6585)' },
  { code: 429, label: 'Too Many Requests (RFC 6585)' },
  { code: 431, label: 'Request Header Fields Too Large (RFC 6585)' },
  { code: 451, label: 'Unavailable For Legal Reasons (RFC 7725)' },
  { code: 500, label: 'Internal Server Error' },
  { code: 501, label: 'Not Implemented' },
  { code: 502, label: 'Bad Gateway' },
  { code: 503, label: 'Service Unavailable' },
  { code: 504, label: 'Gateway Timeout' },
  { code: 505, label: 'HTTP Version Not Supported' },
  { code: 506, label: 'Variant Also Negotiates (RFC 2295)' },
  { code: 507, label: 'Insufficient Storage (WebDAV; RFC 4918)' },
  { code: 508, label: 'Loop Detected (WebDAV; RFC 5842)' },
  { code: 510, label: 'Not Extended (RFC 2774)' },
  { code: 511, label: 'Network Authentication Required (RFC 6585)' },
  { code: 419, label: 'Page Expired (Laravel Framework)' },
  { code: 420, label: 'Method Failure (Spring Framework)' },
  { code: 420, label: 'Enhance Your Calm (Twitter)' },
  { code: 430, label: 'Request Header Fields Too Large (Shopify)' },
  { code: 450, label: 'Blocked by Windows Parental Controls (Microsoft)' },
  { code: 498, label: 'Invalid Token (Esri)' },
  { code: 499, label: 'Token Required (Esri)' },
  { code: 509, label: 'Bandwidth Limit Exceeded (Apache Web Server/cPanel)' },
  { code: 529, label: 'Site is overloaded' },
  { code: 530, label: 'Site is frozen' },
  { code: 598, label: '(Informal convention) Network read timeout error' },
  { code: 599, label: 'Network Connect Timeout Error' },
  { code: 440, label: 'Login Time-out' },
  { code: 449, label: 'Retry With' },
  { code: 451, label: 'Redirect' },
  { code: 444, label: 'No Response' },
  { code: 494, label: 'Request header too large' },
  { code: 495, label: 'SSL Certificate Error' },
  { code: 496, label: 'SSL Certificate Required' },
  { code: 497, label: 'HTTP Request Sent to HTTPS Port' },
  { code: 499, label: 'Client Closed Request' },
  { code: 520, label: 'Web Server Returned an Unknown Error' },
  { code: 521, label: 'Web Server Is Down' },
  { code: 522, label: 'Connection Timed Out' },
  { code: 523, label: 'Origin Is Unreachable' },
  { code: 524, label: 'A Timeout Occurred' },
  { code: 525, label: 'SSL Handshake Failed' },
  { code: 526, label: 'Invalid SSL Certificate' },
  { code: 527, label: 'Railgun Error' },
  { code: 460, label: '' },
  { code: 463, label: '' },
  { code: 464, label: '' },
  { code: 561, label: 'Unauthorized' },
  { code: 110, label: 'Response is Stale' },
  { code: 111, label: 'Revalidation Failed' },
  { code: 112, label: 'Disconnected Operation' },
  { code: 113, label: 'Heuristic Expiration' },
  { code: 199, label: 'Miscellaneous Warning' },
  { code: 214, label: 'Transformation Applied' },
  { code: 299, label: 'Miscellaneous Persistent Warning' },
];
